import { NgClass } from '@angular/common';
import { Component, forwardRef, Input, signal } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-checkbox',
  imports: [FormsModule, NgClass],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.css'
})
export class CheckboxComponent {
  @Input() header: string = '';
  @Input({ required: true }) label_list: string[] = [];
  @Input() is_single_selection: boolean = false;
  @Input() custom_class: string = '';

  // Internal State Signals
  selected_items = signal<string[]>([]);
  is_disabled = signal<boolean>(false);

  // ControlValueAccessor Boilerplate
  on_change: any = () => { };
  on_touched: any = () => { };

  toggle_selection(item_label: string): void {
    if (this.is_disabled()) return;

    const current_selected = this.selected_items();
    let updated_selection: string[];

    if (this.is_single_selection) {
      // Single Selection Mode
      updated_selection = current_selected.includes(item_label) ? [] : [item_label];
    } else {
      // Multiple Selection Mode
      updated_selection = current_selected.includes(item_label)
        ? current_selected.filter((i: any) => i !== item_label)
        : [...current_selected, item_label];
    }

    this.selected_items.set(updated_selection);
    this.on_change(updated_selection);
    this.on_touched();
  }

  // CVA interface methods
  writeValue(value: string[]): void {
    this.selected_items.set(value || []);
  }

  registerOnChange(fn: any): void {
    this.on_change = fn;
  }

  registerOnTouched(fn: any): void {
    this.on_touched = fn;
  }

  setDisabledState(is_disabled: boolean): void {
    this.is_disabled.set(is_disabled);
  }

  is_item_checked(item_label: string): boolean {
    return this.selected_items().includes(item_label);
  }
}
